import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';

const ProtectedRoute = () => {
    const { isAuthenticated, isLoading, checkAuth } = useAuth();
    const [checkedAuth, setCheckedAuth] = useState(false);

    useEffect(() => {
        const verifyAuth = async () => {
            await checkAuth();
            setCheckedAuth(true);
        };

        if (!isAuthenticated && !isLoading) {
            verifyAuth();
        } else {
            setCheckedAuth(true);
        }
    }, [isAuthenticated, isLoading, checkAuth]);

    if (!checkedAuth || isLoading) {
        return <div className="loading-spinner">Loading...</div>;
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;